// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createStateHook,
	createActionsHook,
	type Action,
} from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

const initialState: State = {
	issueKeys: [],
	issueCount: 0,
};

const actions = {
	setIssueKeys:
		(issueKeys: State['issueKeys']): Action<State> =>
		({ setState }) => {
			setState({
				issueKeys,
			});
		},
	setIssueCount:
		(issueCount: State['issueCount']): Action<State> =>
		({ setState }) => {
			setState({ issueCount });
		},
} as const;

const store = createStore<State, typeof actions>({
	initialState,
	actions,
	name: 'queues-issuelist-store',
});

export const useIssueKeys = createStateHook(store, { selector: (state) => state.issueKeys });
export const useIssueCount = createStateHook(store, { selector: (state) => state.issueCount });

const useStoreActions = createActionsHook(store);
export const useSetIssueKeys = () => useStoreActions().setIssueKeys;
export const useSetIssueCount = () => useStoreActions().setIssueCount;
